export default __webpack_public_path__ + "static/media/prepTraining.f1e791b2.svg";